import { render } from "./PigTypePicker.vue?vue&type=template&id=2bc50670&scoped=true&ts=true"
import script from "./PigTypePicker.vue?vue&type=script&lang=ts"
export * from "./PigTypePicker.vue?vue&type=script&lang=ts"

import "./PigTypePicker.vue?vue&type=style&index=0&id=2bc50670&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc50670"]])

export default __exports__